import { Chip } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    chipMenuItem: {
      position: "absolute",
      zIndex: 1,
      background: theme.palette.scgPrimary.main,
      border: "2.5px solid #FFFFFF",
      borderRadius: 12,
      padding: "5px 8px",

      "& .MuiChip-label": {
        padding: 0,
        color: "#ffffff",
        fontSize: 16,
        fontWeight: 700
      }
    }
  }),
  { name: "ChipNumber" }
);

interface ChipNumberProps {
  number: number;
  classesChip: string;
}

const ChipNumber: React.FC<ChipNumberProps> = ({ number, classesChip }) => {
  const classes = useStyles();

  return (
    <Chip
      className={classNames(classes.chipMenuItem, classesChip)}
      label={number}
    />
  );
};

export default ChipNumber;
